jQuery(document).ready(function(){
  jQuery(".menu-button").click(function () {
    jQuery('body').toggleClass('overflow-hidden');
    jQuery(this).toggleClass("is-active");
    jQuery('#mobile-menu').slideToggle();
  });
});

var galleryThumbs = new Swiper('.gallery-thumbs', {
  spaceBetween: 8,
  slidesPerView: 5,
  freeMode: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  slideToClickedSlide: true, // Ensure clicking slides changes the top image
});
var galleryTop = new Swiper('.gallery-top', {
  spaceBetween: 10,
  autoHeight:true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true // Ensures smooth fade transitions
  },
  thumbs: {
    swiper: galleryThumbs
  }
});

// Product Variation Toggle Functionality
document.addEventListener('DOMContentLoaded', function() {
  const variationToggles = document.querySelectorAll('.variation-toggle');

  if (variationToggles.length > 0) {
    variationToggles.forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        const selectedVariation = this.getAttribute('data-variation');

        // Update active state on toggles
        variationToggles.forEach(function(btn) {
          btn.classList.remove('active');
        });
        this.classList.add('active');

        // Get all slides
        const allTopSlides = document.querySelectorAll('.gallery-top .swiper-slide');
        const allThumbSlides = document.querySelectorAll('.gallery-thumbs .swiper-slide');

        // Remove all slides from Swiper wrappers
        allTopSlides.forEach(function(slide) {
          slide.remove();
        });
        allThumbSlides.forEach(function(slide) {
          slide.remove();
        });

        // Get the slides for the selected variation from the stored originals
        const selectedTopSlides = document.querySelectorAll('.gallery-top-original .swiper-slide[data-variation="' + selectedVariation + '"]');
        const selectedThumbSlides = document.querySelectorAll('.gallery-thumbs-original .swiper-slide[data-variation="' + selectedVariation + '"]');

        // Clone and append the selected slides
        const topWrapper = document.querySelector('.gallery-top .swiper-wrapper');
        const thumbWrapper = document.querySelector('.gallery-thumbs .swiper-wrapper');

        selectedTopSlides.forEach(function(slide) {
          const clone = slide.cloneNode(true);
          clone.style.display = '';
          topWrapper.appendChild(clone);
        });

        selectedThumbSlides.forEach(function(slide) {
          const clone = slide.cloneNode(true);
          clone.style.display = '';
          thumbWrapper.appendChild(clone);
        });

        // Destroy and reinitialize Swiper instances to update
        if (galleryThumbs) {
          galleryThumbs.destroy(true, true);
        }
        if (galleryTop) {
          galleryTop.destroy(true, true);
        }

        // Reinitialize Swiper with new slides
        galleryThumbs = new Swiper('.gallery-thumbs', {
          spaceBetween: 8,
          slidesPerView: 5,
          freeMode: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
        });

        galleryTop = new Swiper('.gallery-top', {
          spaceBetween: 10,
          autoHeight: true,
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          },
          thumbs: {
            swiper: galleryThumbs
          }
        });
      });
    });
  }
});



var exploreProducts = new Swiper('.explore-products', {
    loop: false,
    centeredSlides: true,
    speed: 1000,
    slidesPerView: 5,
    initialSlide:2,
    spaceBetween: 16,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    // Navigation arrows
    // navigation: {
    //   nextEl: '.next-occ',
    //   prevEl: '.prev-occ',
    // },
    breakpoints: {
      300: {
        slidesPerView: 2,
        spaceBetween: 4,
      },
      600: {
        slidesPerView: 2,
        // spaceBetween: 6,
      },
      768: {
        slidesPerView: 3,
        // spaceBetween: 6,
      },
      991: {
        slidesPerView: 4,
        // spaceBetween: 10,
      },
      1200: {
        slidesPerView: 5,
      },
      1300: {
        slidesPerView: 5,
      },
    },
  // spaceBetween: 16,
  // freeMode: true,
  // // loop: true,
  // initialSlide: 4,
  // centeredSlides: true,
  // watchSlidesVisibility: true,
  // watchSlidesProgress: true,
  // slideToClickedSlide: true, // Ensure clicking slides changes the top image
});


document.addEventListener('DOMContentLoaded', function() {
    // Get all dropdown items
    var dropdownItems = document.querySelectorAll('.has-dropdown');

    // Add mouseover event to each dropdown item
    dropdownItems.forEach(function(item) {
        item.addEventListener('mouseover', function() {
            // Add 'hovered-item' class to the hovered item
            this.classList.add('hovered-item');
        });

        item.addEventListener('mouseout', function() {
            // Remove 'hovered-item' class when the mouse leaves the item
            this.classList.remove('hovered-item');
        });
    });

    // Get the main menu element
    var mainMenu = document.getElementById('main-menu');

    // Add mouseleave event to the main menu to rotate the icon back
    mainMenu.addEventListener('mouseleave', function() {
        // Find any items with the 'hovered-item' class and remove it
        var hoveredItems = mainMenu.querySelectorAll('.hovered-item');
        hoveredItems.forEach(function(hoveredItem) {
            hoveredItem.classList.remove('hovered-item');
        });
    });

    // Shorten language switcher text to EN/ES on mobile only
    function updateLanguageSwitcherText() {
        if (window.innerWidth <= 991) {
            var mobileLangButton = document.querySelector('.wpml-language-switcher-mobile-visible button');
            if (mobileLangButton) {
                var currentText = mobileLangButton.textContent.trim();
                var shortText = currentText.substring(0, 2).toUpperCase();

                // Store original text if not already stored
                if (!mobileLangButton.hasAttribute('data-original-text')) {
                    mobileLangButton.setAttribute('data-original-text', currentText);
                }

                // Replace text content but keep the SVG
                var svg = mobileLangButton.querySelector('svg');
                mobileLangButton.textContent = shortText;
                if (svg) {
                    mobileLangButton.appendChild(svg);
                }
            }
        }
    }

    // Run on load
    updateLanguageSwitcherText();

    // Run on resize
    var resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            updateLanguageSwitcherText();
        }, 250);
    });
});